import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import {
    setCurrentSection,
    resetForm,
  } from '../registration/registrationSlice';
const LinkedInFollow = () => {
    const API_URL = process.env.REACT_APP_API_URL;
    const [isChecked, setIsChecked] = useState(false);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const formData = useSelector((store) => store.registration);
    const currentSection = formData.currentSection;
    const sectionOneData = formData.sectionOneData;

    const [validationError, setValidationError] = useState(false);
    const [errorMessages, setErrorMessages] = useState("");

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    const handlePreviousSection = () => {
        if (currentSection === 3) {
          dispatch(setCurrentSection(2));
        }
      };
    


    const handleNextSection = (e) => {
        e.preventDefault();
        const studentType = formData.sectionOneData.studentType;
        const studentTypeFlag = studentType === "partnership";

        setLoading(true);

        const userInfo = {
            firstName: formData.sectionOneData.firstName || "",
            lastName: formData.sectionOneData.lastName || "",
            dateofbirth:formData.sectionOneData.birthDay+"-" + formData.sectionOneData.birthMonth+"-" + formData.sectionOneData.birthYear || "",
            email: formData.sectionOneData.email || "",
            phone: formData.sectionOneData.phoneNo || "",
            linkedinUrl: formData.sectionOneData.linkedIn || "",
            city: formData.sectionOneData.city || "",
            homeTown: formData.sectionOneData.hometown || "",
            gender: formData.sectionOneData.gender || "",
            state: formData.sectionOneData.stateName || "",
            middleName: formData.sectionOneData.middleName || "",
            studentType: formData.sectionOneData.studentType || "",
            collegeId: studentTypeFlag ? formData.sectionTwoData.collegeId : "",
            branchId: studentTypeFlag ? formData.sectionTwoData.branchId : "",
            plannedPassOutYear: formData.sectionTwoData.passoutBatch || "",
            collegeRollNo: formData.sectionTwoData.collegeRollNo || "",
            referenceAssociateName: studentTypeFlag
              ? ""
              : formData.sectionTwoData.referenceAssociateName,
            employeeId: studentTypeFlag ? "" : formData.sectionTwoData.referenceAssociateId,
            associateCollegeName: studentTypeFlag
              ? ""
              : formData.sectionTwoData.nameOfCollege,
            associateUniversity: formData.sectionTwoData.university || "",
            associateBranchName: studentTypeFlag ? "" : formData.sectionTwoData.nameOfBranch,
            associatePlannedPassOutYear: formData.sectionTwoData.passoutBatch || "",
            associateCollegeRollNo: formData.sectionTwoData.collegeRollNo || "",
            associateCollegeCity: formData.sectionTwoData.collegeCity || "",
            associateCollegeState: formData.sectionTwoData.collegeState || "",
          };
    
          console.log("Submitting data:", userInfo);
          console.log("Submitting data:", JSON.stringify(userInfo));
    
          fetch(API_URL + "/api/students/register", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(userInfo),
          })
            .then((response) => {
              if (!response.ok) {
                if (response.status === 400) {
                  return response.json();
                } else {
                  throw new Error(`Error: ${response.status}`);
                }
              }
              return response.json(); // assuming the response is JSON
            })
            .then((responseData) => {
              if (responseData.success === true) {
                localStorage.setItem('email', responseData.data.email);
                localStorage.setItem('student_id',responseData.data.id)
                dispatch(resetForm());
                
                dispatch(setCurrentSection(4));
              } else {
                setLoading(false);
                setValidationError(true);
                const data = responseData.data;
                if (
                  typeof data === "object" &&
                  !Array.isArray(data) &&
                  data !== null
                ) {
                  setErrorMessages(data);
                } else {
                  setErrorMessages({ errormsg: data });
                }
              }
              console.log("responseData:", responseData);
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        
    };

    return (
    
        <div>
          

            <div className="flex items-center justify-center px-4 py-6 md:py-8">

                <div className="bg-white p-4 sm:p-8 w-full">
                    <div className="w-full bg-white py-6  items-center flex justify-center">
                        <form onSubmit={handleNextSection} className="flex flex-col items-center">
                            <div className="flex items-center mb-4 w-full pl-4">
                                <input
                                    type="checkbox"
                                    id="linkedinCheckbox"
                                    checked={isChecked}
                                    onChange={handleCheckboxChange}
                                    className=" w-8 h-8 mr-5 accent-blue-700 border-2 border-green-300 rounded "
                                />
                                <div htmlFor="linkedinCheckbox" className="text-xl md:text-2xl font-semibold">
                                    Have you followed us on LinkedIn?
                                </div>
                            </div>

                            <a
                                href="https://www.linkedin.com/company/agivanttech/posts/?feedView=all"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-700 text-lg mb-4 hover:underline w-full text-center"
                            >
                                Click here to follow Agivant LinkedIn Page
                            </a>

                            <p className="text-sm text-gray-600 mb-6 w-full text-center font-normal">
                                We will keep sharing key updates regarding this program on our LinkedIn page.
                            </p>

                            <button
                                type="submit"
                                className={`bg-blue-700 text-white py-2 px-8 rounded transition duration-300 ${
                                    loading ? "bg-blue-500 cursor-not-allowed" : "hover:bg-blue-800"
                                }`}
                                disabled={loading}
                            >
                                {loading ? "Submit..." : "Submit"}
                            </button>

                        </form>

                        
                    </div>
                    {validationError && (
                          <div>
                            {Object.keys(errorMessages).map((key) => {
                              const errorMessage = errorMessages[key];
                              return <p className="text-red-500 text-sm mt-1 font-normal" key={key}>{errorMessage}</p>;
                            })}
                          </div>
                        )}
                </div>


            </div>
            <button onClick={handlePreviousSection} className="w-28 px-2 py-2 mb-6 ml-6 bg-gray-300 text-center rounded-md">
                Back
            </button>
          
        </div>
    );
};



export default LinkedInFollow;
